import Inputmask from "inputmask";
import Glide from '@glidejs/glide';


export default () => {
    const phoneForm = document.getElementById('sign-in-form');
    const codeForm = document.getElementById('code-form');
    const passForm = document.getElementById('pass-form');
    //const codeText = document.getElementById('code-text');
    const phoneField = document.getElementById("phone-number");
    const codeField = document.getElementById("verification-code");
    const passField = document.getElementById("pass-code");
    const mailField = document.getElementById("pass-email");
    const setCodeButton = document.getElementById("setcode-button");
    const authButton = document.getElementById("auth-button");
    const resetButton = document.getElementById("reset-button");
    const phoneNumber = document.getElementById('phone-number-msg');
    const errorMsg = document.getElementById("errorMsg");
    const errorMsgCode = document.getElementById("errorMsgCode");
    const errorMsgPass = document.getElementById("errorMsgPass");
    const errorMsgReq = document.getElementById("errorMsgReq");
    const reqSubmit = document.getElementById("message-button");
    const exit = document.body.classList.contains('exit');
    const error = document.body.classList.contains('error');
    const user = {
        phone: '',
        code: ''
    }
    const emailIsValid = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const passISLatin = string => /^[A-Za-z0-9]+$/.test(string);
    const isFilled = string => string.trim() !== '';

    if(error){
        phoneForm.style.display = 'none';
        document.getElementById('connect-error').style.display = 'block';
        return false;
    }
    if(exit){
        window.location.href = '/login';
        return false;
    }
    passField.oninput = function (){
        if(this.value === ''){
            errorMsgPass.innerText = ''
            return false;
        }
        if(!passISLatin(this.value)){
            errorMsgPass.innerText = 'Только латинские буквы, знаки и цифры';
        }else{
            errorMsgPass.innerText = '';
        }
    }

    const im = new Inputmask({
    mask: "+99999999999",
        placeholder: '',
        //onincomplete: function(){ phoneField.placeholder = "" },
        oncomplete: function(){
            const unValue = phoneField.inputmask.unmaskedvalue();
            isPhoneValid(unValue);
        },
        onKeyDown: function(){
            errorMsg.innerHTML = "";
            phoneField.classList.remove('success');
            let unValue = phoneField.inputmask.unmaskedvalue();
            if(unValue[0] === '8'){
                phoneField.value = `7${unValue.slice(1)}`;
            }
        }
    });

    const imm = new Inputmask({
        mask: "+99999999999",
        placeholder: '',
        oncomplete: function(){
            const unValue = phoneNumber.inputmask.unmaskedvalue();
            isPhoneExist(unValue);
        },
        onKeyDown: function(){
            errorMsg.innerHTML = "";
            phoneNumber.classList.remove('success');
            let unValue = phoneNumber.inputmask.unmaskedvalue();
            if(unValue[0] === '8'){
                phoneField.value = `7${unValue.slice(1)}`;
            }
        }
    });

    im.mask(phoneField);
    imm.mask(phoneNumber);


    const isPhoneValid = (num) => {

        errorMsg.innerHTML = "";
        if (num[0] !== '7') {
            errorMsg.innerHTML = "Только международный формат";
        } else if (num[1] !== '9') {
            errorMsg.innerHTML = "Только Мобильные";
        } else if (num.length !== 11) {
            errorMsg.innerHTML = "Проверьте номер";
        }else{
            user.phone = `+${num}`;
            let data = new FormData();
            data.append('user', user.phone);
            //console.log(user.phone);
            fetch('/login/check', {
                method: 'POST',
                body: data
            })
                .then(result => result.json())
                .then((result) => {

                    if(result.type === false){
                        errorMsg.innerHTML = result.value;
                    }
                    else if(result.type === "setcode"){
                        phoneForm.style.display = 'none';
                        passForm.style.display = 'block';
                        document.getElementById('slogan').classList.add("active");
                        document.getElementById('form').classList.add("active");
                        passField.focus();
                        setCodeButton.onclick = (e) => {e.preventDefault(); setCode(result.value, passField.value, mailField.value);}
                        //console.log(result.value);
                    }
                    else if(result.type === "code"){
                        phoneForm.style.display = 'none';
                        codeForm.style.display = 'block';
                        document.getElementById('slogan').classList.add("active");
                        document.getElementById('form').classList.add("active");
                        codeField.focus();
                        authButton.onclick = (e) => {e.preventDefault(); checkCode(result.value, codeField.value);}
                        resetButton.onclick = (e) => {e.preventDefault(); resetUser(result.value);}
                    }
                })
                .catch(function(err) {
                    console.log('Fetch Error :-S', err);
                });
        }
    };

    const isPhoneExist = (num) => {
        let data = new FormData();
        data.append('user', `+7${num}`);
        console.log(num);
        fetch('/login/exist', {
            method: 'POST',
            body: data
        })
            .then(result => result.text())
            .then((result) => {
                console.log(result);
                if (result !== "false") {
                    errorMsgReq.innerHTML = "Клиент с таким номером уже существует";
                    reqSubmit.disabled = true;
                } else {
                    phoneNumber.classList.add('success');
                    errorMsgReq.innerHTML = "";
                    reqSubmit.disabled = false;
                }
            })
            .catch(function(err) {
                console.log('Fetch Error :-S', err);
            });
    }

    const loginUser = (phone) => {
        if(phone !== 'error'){
            let data = new FormData();
            data.append('user', phone);
            fetch('/login/auth',
                {
                    method: 'POST',
                    body: data
                }
            )
                .then(() => { window.location.href = '/'; });
        }else{
            alert('Ошибка, попробуйте еще раз');
        }
    }

    const resetUser = (phone) => {
        if(phone !== 'error'){
            let data = new FormData();
            data.append('user', phone);
            fetch('/login/reset',
                {
                    method: 'POST',
                    body: data
                }
            )
            .then(result => result.text())
            .then(result => {
                window.location.href=result;
            });
        }else{
            alert('Ошибка, попробуйте еще раз');
        }

    }

    const checkCode = (phone, pass) => {
        let data = new FormData();
        data.append('phone', phone);
        data.append('code', pass);
        fetch('/login/pass',
            {
                method: 'POST',
                body: data
            }
        )
            .then(result => result.text())
            .then(result => {
                if(result !== 'error'){
                    loginUser(result);
                }else{
                    errorMsgCode.innerText = 'Неверный пароль';
                }
            });
    };


    const setCode = (phone, pass, mail) => {

        if(!isFilled(pass)){
            document.getElementById('errorMsgPass').innerText = 'Пароль не может быть пустым';
            return false;
        }
        if(!emailIsValid(mail)){
            document.getElementById('errorMsgMail').innerText = 'E-mail указан с ошибкой';
            return false;
        }
        let data = new FormData();
        data.append('phone', phone);
        data.append('code', pass);
        data.append('mail', mail);
        fetch('/login/set',
            {
                method: 'POST',
                body: data
            }
        )
            .then(result => result.text())
            .then(result => loginUser(result));
    };

    reqSubmit.onclick = function () {
        let contact = document.getElementById('contact').value;
        let phoneNumber = document.getElementById('phone-number-msg').value;
        let company = document.getElementById('company').value;
        let companyDesc = document.getElementById('company_desc').value;
        if (contact !== '' && phoneNumber !== '' && company !== '') {
            let data = new FormData();
            data.append('contact', contact);
            data.append('phone', phoneNumber);
            data.append('company', company);
            data.append('company_desc', companyDesc);
            fetch('/request', {
                method: 'POST',
                body: data
            }).then(result => result.text()).then((result) => {
                if (result === "Сообщение уже у нас, мы скоро перезвоним вам!") {
                    document.getElementById('message-text').innerHTML = result;
                    document.getElementById('request-form').reset();
                } else {
                    document.getElementById('message-text').innerHTML = result;
                }
            });
        } else {
            document.getElementById('message-text').innerHTML = "Проверьте контактные данные";
        }

    };


    const glide =  new Glide('.glide', {
        type: 'carousel',
        autoplay: 0.1,
        animationTimingFunc: 'linear',
        perView: 5,
        animationDuration:1500,
        breakpoints: {
            1024: {
                perView: 3,
            },
            768: {
                perView: 2,
            }
        }
    });
    glide.mount();
};
